export default "__VITE_ASSET__CnQGWJAH__"